export default "https://cdn-static.gokick.com/assets/34e3985c60c1a4021cd40bb2eb2cab3e4962f61f/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";